import React, { useState } from "react";
import { ChevronDown } from "lucide-react";
import DashboardGuestRow from "./DashboardGuestRow";

export default function DashboardTentativeGuestList({
  tentativeRsvps,
  removingId,
  onRequestRemove,
  hostName = "",
  schoolName = "",
}) {
  const [open, setOpen] = useState(false);

  return (
    <details
      className="group pt-3 border-t border-black/[0.08]"
      open={open}
      onToggle={(e) => setOpen(e.currentTarget.open)}
      data-testid="dash-tentative-list-panel"
    >
      <summary
        aria-expanded={open}
        className="font-ui font-medium text-[13px] text-ink/70 cursor-pointer list-none flex items-center gap-1.5 [&::-webkit-details-marker]:hidden min-h-[44px] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-plum"
      >
        Maybe or can&apos;t make it
        <span className="tabular-nums">· {tentativeRsvps.length}</span>
        <ChevronDown
          className="w-4 h-4 text-ink/50 ml-auto transition-transform motion-reduce:transition-none group-open:rotate-180"
          strokeWidth={2.5}
          aria-hidden
        />
      </summary>
      <div className="mt-2 space-y-2" data-testid="dash-tentative-list">
        {tentativeRsvps.map((r) => (
          <DashboardGuestRow
            key={r.id}
            r={r}
            tentative
            removing={removingId === r.dancer_id}
            onRequestRemove={() => onRequestRemove(r)}
            hostName={hostName}
            schoolName={schoolName}
          />
        ))}
      </div>
    </details>
  );
}
